// 百科统一入口：语言字段在同目录维护，逻辑与显示映射在此集中管理。
import * as simplified from "./zh-CN.js";
import * as traditional from "./zh-HK.js";
import * as english from "./en-US.js";
export const zhCN = simplified.messages;
export const zhHK = traditional.messages;
export const enUS = english.messages;

// 分区导出保留原有接口，词条只在语言文件中保存一份。
export const wikiDisplayZhCN = simplified.display;
export const wikiDisplayZhHK = traditional.display;
export const wikiDisplayEnUS = english.display;
export const wikiPagesZhCN = simplified.pages;
export const wikiPagesZhHK = traditional.pages;
export const wikiPagesEnUS = english.pages;
export const pcPersonalWikiZhCN = simplified.personal;
export const pcPersonalWikiZhHK = traditional.personal;
export const pcPersonalWikiEnUS = english.personal;

export const wikiFixedLabelKeys = Object.freeze({
  容量: "wikiDisplay.parameter.capacity",
  Capacity: "wikiDisplay.parameter.capacity",
  存储密度: "wikiDisplay.parameter.density",
  Density: "wikiDisplay.parameter.density",
  儲存密度: "wikiDisplay.parameter.density",
  访问时间: "wikiDisplay.parameter.accessTime",
  "Access time": "wikiDisplay.parameter.accessTime",
  存取時間: "wikiDisplay.parameter.accessTime",
  封装: "wikiDisplay.parameter.package",
  Package: "wikiDisplay.parameter.package",
  封裝: "wikiDisplay.parameter.package",
  电压: "wikiDisplay.parameter.voltage",
  Voltage: "wikiDisplay.parameter.voltage",
  電壓: "wikiDisplay.parameter.voltage",
  工作电压: "wikiDisplay.parameter.operatingVoltage",
  "Operating voltage": "wikiDisplay.parameter.operatingVoltage",
  工作電壓: "wikiDisplay.parameter.operatingVoltage",
  供电电压: "wikiDisplay.parameter.supplyVoltage",
  "Supply voltage": "wikiDisplay.parameter.supplyVoltage",
  供電電壓: "wikiDisplay.parameter.supplyVoltage",
  速率: "wikiDisplay.parameter.speed",
  Speed: "wikiDisplay.parameter.speed",
  频率: "wikiDisplay.parameter.frequency",
  Frequency: "wikiDisplay.parameter.frequency",
  頻率: "wikiDisplay.parameter.frequency",
  工作温度: "wikiDisplay.parameter.temperature",
  "Operating temperature": "wikiDisplay.parameter.temperature",
  工作溫度: "wikiDisplay.parameter.temperature",
  接口: "wikiDisplay.parameter.interface",
  Interface: "wikiDisplay.parameter.interface",
  介面: "wikiDisplay.parameter.interface",
  位宽: "wikiDisplay.parameter.width",
  "Bus width": "wikiDisplay.parameter.width",
  位寬: "wikiDisplay.parameter.width",
  组织: "wikiDisplay.parameter.organization",
  Organization: "wikiDisplay.parameter.organization",
  組織: "wikiDisplay.parameter.organization",
  引脚数: "wikiDisplay.parameter.pins",
  "Pin count": "wikiDisplay.parameter.pins",
  引腳數: "wikiDisplay.parameter.pins",
  制程: "wikiDisplay.parameter.process",
  Process: "wikiDisplay.parameter.process",
  製程: "wikiDisplay.parameter.process",
  功耗: "wikiDisplay.parameter.power",
  "Power consumption": "wikiDisplay.parameter.power",
  品牌厂商: "wikiDisplay.parameter.brand",
  "Brand / manufacturer": "wikiDisplay.parameter.brand",
  "品牌／廠商": "wikiDisplay.parameter.brand",
  制造商: "wikiDisplay.parameter.manufacturer",
  Manufacturer: "wikiDisplay.parameter.manufacturer",
  製造商: "wikiDisplay.parameter.manufacturer",
  所属分类: "wikiDisplay.parameter.category",
  Category: "wikiDisplay.parameter.category",
  所屬分類: "wikiDisplay.parameter.category",
  型号: "wikiDisplay.parameter.model",
  Model: "wikiDisplay.parameter.model",
  型號: "wikiDisplay.parameter.model",
  供货状态: "wikiDisplay.parameter.period",
  "Supply status": "wikiDisplay.parameter.period",
  供貨狀態: "wikiDisplay.parameter.period",
  内容描述: "wikiDisplay.parameter.description",
  Description: "wikiDisplay.parameter.description",
  內容描述: "wikiDisplay.parameter.description",
  基础资料: "wikiDisplay.parameter.base",
  "Basic information": "wikiDisplay.parameter.base",
  基本資料: "wikiDisplay.parameter.base",
  核心规格: "wikiDisplay.parameter.spec",
  "Core specifications": "wikiDisplay.parameter.spec",
  核心規格: "wikiDisplay.parameter.spec",
  封装信息: "wikiDisplay.parameter.packaging",
  "Package information": "wikiDisplay.parameter.packaging",
  封裝資料: "wikiDisplay.parameter.packaging",
  参数: "wikiDisplay.parameter.parameter",
  Parameter: "wikiDisplay.parameter.parameter",
  參數: "wikiDisplay.parameter.parameter",
  规格书: "wikiDisplay.parameter.datasheet",
  Datasheet: "wikiDisplay.parameter.datasheet",
  規格書: "wikiDisplay.parameter.datasheet",
  百科正文: "wikiDisplay.parameter.body",
  "Encyclopedia content": "wikiDisplay.parameter.body",
  数据速率: "wikiDisplay.parameter.dataRate",
  "Data rate": "wikiDisplay.parameter.dataRate",
  資料速率: "wikiDisplay.parameter.dataRate",
  产品名称: "wikiDisplay.parameter.productName",
  "Product name": "wikiDisplay.parameter.productName",
  產品名稱: "wikiDisplay.parameter.productName",
  料号型号: "wikiDisplay.parameter.partNumber",
  "Part number": "wikiDisplay.parameter.partNumber",
  料號型號: "wikiDisplay.parameter.partNumber",
  产品系列: "wikiDisplay.parameter.series",
  "Product series": "wikiDisplay.parameter.series",
  產品系列: "wikiDisplay.parameter.series",
  参考单价: "wikiDisplay.parameter.price",
  "Reference unit price": "wikiDisplay.parameter.price",
  參考單價: "wikiDisplay.parameter.price",
  库存数量: "wikiDisplay.parameter.quantity",
  "Stock quantity": "wikiDisplay.parameter.quantity",
  庫存數量: "wikiDisplay.parameter.quantity",
  货所在地: "wikiDisplay.parameter.location",
  "Stock location": "wikiDisplay.parameter.location",
  貨物所在地: "wikiDisplay.parameter.location",
  批次: "wikiDisplay.parameter.batch",
  Batch: "wikiDisplay.parameter.batch",
  货物情况: "wikiDisplay.parameter.condition",
  Condition: "wikiDisplay.parameter.condition",
  貨物狀況: "wikiDisplay.parameter.condition",
  应用领域: "wikiDisplay.parameter.application",
  Applications: "wikiDisplay.parameter.application",
  應用領域: "wikiDisplay.parameter.application",
  起订量: "wikiDisplay.parameter.moq",
  "Minimum order quantity": "wikiDisplay.parameter.moq",
  最低訂購量: "wikiDisplay.parameter.moq",
  交货周期: "wikiDisplay.parameter.leadTime",
  "Delivery lead time": "wikiDisplay.parameter.leadTime",
  交貨期: "wikiDisplay.parameter.leadTime",
  有效期: "wikiDisplay.parameter.validity",
  Validity: "wikiDisplay.parameter.validity",
  替代型号: "wikiDisplay.parameter.alternative",
  "Alternative model": "wikiDisplay.parameter.alternative",
  替代型號: "wikiDisplay.parameter.alternative",
  "CAS 延迟": "wikiDisplay.parameter.cas",
  "CAS latency": "wikiDisplay.parameter.cas",
  "CAS 延遲": "wikiDisplay.parameter.cas",
  草稿: "wikiDisplay.status.draft",
  Draft: "wikiDisplay.status.draft",
  待审核: "wikiDisplay.status.reviewing",
  "Pending review": "wikiDisplay.status.reviewing",
  待審核: "wikiDisplay.status.reviewing",
  审核中: "wikiDisplay.status.processing",
  "Under review": "wikiDisplay.status.processing",
  審核中: "wikiDisplay.status.processing",
  人工复核: "wikiDisplay.status.manual",
  "Manual review": "wikiDisplay.status.manual",
  人工覆核: "wikiDisplay.status.manual",
  待确认: "wikiDisplay.status.confirm",
  "Awaiting confirmation": "wikiDisplay.status.confirm",
  待確認: "wikiDisplay.status.confirm",
  需修改: "wikiDisplay.status.revision",
  "Revision required": "wikiDisplay.status.revision",
  审核不通过: "wikiDisplay.status.rejected",
  "Review failed": "wikiDisplay.status.rejected",
  審核不通過: "wikiDisplay.status.rejected",
  已拒绝: "wikiDisplay.status.denied",
  Rejected: "wikiDisplay.status.denied",
  已拒絕: "wikiDisplay.status.denied",
  已发布: "wikiDisplay.status.published",
  Published: "wikiDisplay.status.published",
  已發佈: "wikiDisplay.status.published",
  已下架: "wikiDisplay.status.offline",
  Offline: "wikiDisplay.status.offline",
  计划发布: "wikiDisplay.status.scheduled",
  Scheduled: "wikiDisplay.status.scheduled",
  排程發佈: "wikiDisplay.status.scheduled",
  待审核版本预览: "wikiDisplay.review.pendingPreview",
  "Pending version preview": "wikiDisplay.review.pendingPreview",
  待審核版本預覽: "wikiDisplay.review.pendingPreview",
  百科查看详情: "wikiDisplay.review.view",
  "Encyclopedia details": "wikiDisplay.review.view",
  百科詳情: "wikiDisplay.review.view",
  "当前展示的是用户本次提交的修改内容，不是百科库中的已发布版本。":
    "wikiDisplay.review.pendingVersionHint",
  "This is the user's submitted revision, not the published version.":
    "wikiDisplay.review.pendingVersionHint",
  "目前顯示的是用戶本次提交的修改內容，並非百科庫中的已發佈版本。":
    "wikiDisplay.review.pendingVersionHint",
  "当前为查看入口，只查看该百科条目的公开展示内容和发布状态。":
    "wikiDisplay.review.readOnlyHint",
  "This read-only view shows the entry's public content and publication status.":
    "wikiDisplay.review.readOnlyHint",
  "目前為查看入口，只顯示此百科條目的公開內容及發佈狀態。":
    "wikiDisplay.review.readOnlyHint",
  内部百科管理详情: "wikiDisplay.review.internal",
  "Internal encyclopedia management": "wikiDisplay.review.internal",
  內部百科管理詳情: "wikiDisplay.review.internal",
  该百科内容正在审核: "wikiDisplay.review.processingTitle",
  "This content is under review": "wikiDisplay.review.processingTitle",
  此百科內容正在審核: "wikiDisplay.review.processingTitle",
  "这是你的提交预览，内容暂未进入公开百科库。审核通过后，其他用户才能在百科详情中看到正式版本。":
    "wikiDisplay.review.processingHint",
  "This submission preview is not public. Other users can see the published version after approval.":
    "wikiDisplay.review.processingHint",
  "這是你的提交預覽，內容尚未進入公開百科庫。審核通過後，其他用戶才能查看正式版本。":
    "wikiDisplay.review.processingHint",
  "AI 已生成修正建议": "wikiDisplay.review.aiTitle",
  "AI corrections are available": "wikiDisplay.review.aiTitle",
  "AI 已生成修正建議": "wikiDisplay.review.aiTitle",
  "请核对下方修改前后对比；接受后会重新审核，不确认则转人工复核。":
    "wikiDisplay.review.aiHint",
  "Compare the original and proposed changes. Acceptance triggers another review; otherwise manual review is required.":
    "wikiDisplay.review.aiHint",
  "請核對下方修改前後對比；接受後會重新審核，未確認則轉人工覆核。":
    "wikiDisplay.review.aiHint",
  该百科内容正在人工复核: "wikiDisplay.review.manualTitle",
  "This content is under manual review": "wikiDisplay.review.manualTitle",
  此百科內容正在人工覆核: "wikiDisplay.review.manualTitle",
  "人工审核通过后发布；不通过会退回到“需修改”。":
    "wikiDisplay.review.manualHint",
  "Approved content will be published; otherwise it will be returned for revision.":
    "wikiDisplay.review.manualHint",
  "人工審核通過後發佈；未通過則退回至「需修改」。":
    "wikiDisplay.review.manualHint",
  该百科内容已退回修改: "wikiDisplay.review.revisionTitle",
  "This content was returned for revision": "wikiDisplay.review.revisionTitle",
  此百科內容已退回修改: "wikiDisplay.review.revisionTitle",
  "请根据审核意见修正后重新提交。": "wikiDisplay.review.revisionHint",
  "Revise according to the review feedback and resubmit.":
    "wikiDisplay.review.revisionHint",
  "請按審核意見修正後重新提交。": "wikiDisplay.review.revisionHint",
  该百科内容未通过审核: "wikiDisplay.review.rejectedTitle",
  "This content did not pass review": "wikiDisplay.review.rejectedTitle",
  此百科內容未通過審核: "wikiDisplay.review.rejectedTitle",
  "该版本已终止发布，具体原因请查看下方审核意见。":
    "wikiDisplay.review.rejectedHint",
  "Publication of this version has stopped. See the review feedback below.":
    "wikiDisplay.review.rejectedHint",
  "此版本已終止發佈，具體原因請查看下方審核意見。":
    "wikiDisplay.review.rejectedHint",
  该百科内容已由管理员下架: "wikiDisplay.review.offlineTitle",
  "An administrator took this content offline":
    "wikiDisplay.review.offlineTitle",
  此百科內容已由管理員下架: "wikiDisplay.review.offlineTitle",
  "该内容已停止公开展示，具体原因请查看下方管理意见。":
    "wikiDisplay.review.offlineHint",
  "This content is no longer public. See the management feedback below.":
    "wikiDisplay.review.offlineHint",
  "此內容已停止公開顯示，具體原因請查看下方管理意見。":
    "wikiDisplay.review.offlineHint",
  该百科有未提交的修改草稿: "wikiDisplay.review.draftTitle",
  "This entry has an unsubmitted revision": "wikiDisplay.review.draftTitle",
  此百科有尚未提交的修改草稿: "wikiDisplay.review.draftTitle",
  "当前草稿仅你本人可见；已发布版本仍正常对外展示。":
    "wikiDisplay.review.draftHint",
  "Only you can see this draft; the published version remains public.":
    "wikiDisplay.review.draftHint",
  "目前草稿僅你本人可見；已發佈版本仍正常公開顯示。":
    "wikiDisplay.review.draftHint",
  该百科投稿已撤回: "wikiDisplay.review.withdrawnTitle",
  "This submission was withdrawn": "wikiDisplay.review.withdrawnTitle",
  此百科投稿已撤回: "wikiDisplay.review.withdrawnTitle",
  "当前内容仅你本人可见，不再进入审核队列。":
    "wikiDisplay.review.withdrawnHint",
  "Only you can see this content; it is no longer in the review queue.":
    "wikiDisplay.review.withdrawnHint",
  "目前內容僅你本人可見，不再進入審核佇列。":
    "wikiDisplay.review.withdrawnHint",
  该百科内容已发布: "wikiDisplay.review.publishedTitle",
  "This content is published": "wikiDisplay.review.publishedTitle",
  此百科內容已發佈: "wikiDisplay.review.publishedTitle",
  "这是已通过审核的公开百科详情，用户可以从百科库和相关产品入口访问。":
    "wikiDisplay.review.publishedHint",
  "This approved entry is public and accessible from the encyclopedia and related products.":
    "wikiDisplay.review.publishedHint",
  "這是已通過審核的公開百科詳情，用戶可從百科庫及相關產品入口查看。":
    "wikiDisplay.review.publishedHint",
  等待人工审核结论: "wikiDisplay.review.waitManual",
  "Awaiting manual review": "wikiDisplay.review.waitManual",
  等待人工審核結果: "wikiDisplay.review.waitManual",
  等待内部确认后发布: "wikiDisplay.review.waitInternal",
  "Awaiting internal approval for publication":
    "wikiDisplay.review.waitInternal",
  等待內部確認後發佈: "wikiDisplay.review.waitInternal",
  已允许进入公开百科库: "wikiDisplay.review.allowed",
  "Approved for the public encyclopedia": "wikiDisplay.review.allowed",
  已允許進入公開百科庫: "wikiDisplay.review.allowed",
  已停止公开展示: "wikiDisplay.review.hidden",
  "No longer publicly visible": "wikiDisplay.review.hidden",
  已停止公開顯示: "wikiDisplay.review.hidden",
  该版本已终止发布: "wikiDisplay.review.stopped",
  "Publication of this version has stopped": "wikiDisplay.review.stopped",
  此版本已終止發佈: "wikiDisplay.review.stopped",
  "内部暂存，未进入公开库": "wikiDisplay.review.internalDraft",
  "Internal draft, not public": "wikiDisplay.review.internalDraft",
  "內部暫存，尚未進入公開庫": "wikiDisplay.review.internalDraft",
  "当前展示用户本次提交的待审核版本。请核对内容后选择审核通过或退回修改。":
    "wikiDisplay.review.checkSubmitted",
  "Review this submitted version and approve it or return it for revision.":
    "wikiDisplay.review.checkSubmitted",
  "目前顯示用戶本次提交的待審核版本。請核對後選擇通過或退回修改。":
    "wikiDisplay.review.checkSubmitted",
  "该条目来自百科审核队列，可在此核对图片、参数、词条字段和内容描述后再确认发布。":
    "wikiDisplay.review.checkQueue",
  "Check the images, parameters, fields and description before approving publication.":
    "wikiDisplay.review.checkQueue",
  "此條目來自百科審核佇列，請核對圖片、參數、詞條欄位及內容描述後確認發佈。":
    "wikiDisplay.review.checkQueue",
  "该条目已通过审核并进入百科库，可继续核对资料完整度或补齐规格、图片、商品关联信息。":
    "wikiDisplay.review.checkPublished",
  "This approved entry is public. You may check completeness and add specifications, images or product links.":
    "wikiDisplay.review.checkPublished",
  "此條目已通過審核並進入百科庫，可繼續核對完整度或補充規格、圖片及商品關聯資料。":
    "wikiDisplay.review.checkPublished",
  "该词条已下架，不会进入用户修改队列；如需恢复，请先转为人工复核并重新审核。":
    "wikiDisplay.review.checkOffline",
  "This entry is offline. Restore it through manual review rather than the user revision queue.":
    "wikiDisplay.review.checkOffline",
  "此詞條已下架，不會進入用戶修改佇列；如需恢復，請先轉人工覆核並重新審核。":
    "wikiDisplay.review.checkOffline",
  "该版本未通过人工审核，不能继续进入发布流程。":
    "wikiDisplay.review.checkRejected",
  "This version failed manual review and cannot proceed to publication.":
    "wikiDisplay.review.checkRejected",
  "此版本未通過人工審核，不能繼續進入發佈流程。":
    "wikiDisplay.review.checkRejected",
  "该条目处于内部草稿状态，可继续补齐资料后转入待审核或直接发布。":
    "wikiDisplay.review.checkDraft",
  "This is an internal draft. Complete it before submitting for review or publishing.":
    "wikiDisplay.review.checkDraft",
  "此條目為內部草稿，可補齊資料後轉入待審核或直接發佈。":
    "wikiDisplay.review.checkDraft",
  审核通过并发布: "wikiDisplay.review.approve",
  "Approve and publish": "wikiDisplay.review.approve",
  審核通過並發佈: "wikiDisplay.review.approve",
  退回修改: "wikiDisplay.review.return",
  "Return for revision": "wikiDisplay.review.return",
  退回补充: "wikiDisplay.review.returnMore",
  "Return for more information": "wikiDisplay.review.returnMore",
  退回補充: "wikiDisplay.review.returnMore",
  下架转待审: "wikiDisplay.review.offlinePending",
  "Take offline for review": "wikiDisplay.review.offlinePending",
  下架轉待審: "wikiDisplay.review.offlinePending",
  重新待审: "wikiDisplay.review.pendingAgain",
  "Return to pending review": "wikiDisplay.review.pendingAgain",
  重新待審: "wikiDisplay.review.pendingAgain",
  保存草稿: "wikiDisplay.review.saveDraft",
  "Save draft": "wikiDisplay.review.saveDraft",
  儲存草稿: "wikiDisplay.review.saveDraft",
  制定审核计划: "wikiDisplay.review.plan",
  "Plan review": "wikiDisplay.review.plan",
  制定審核計劃: "wikiDisplay.review.plan",
  识别产品型号: "wikiDisplay.review.identify",
  "Identify product model": "wikiDisplay.review.identify",
  識別產品型號: "wikiDisplay.review.identify",
  检索规格书证据: "wikiDisplay.review.retrieve",
  "Retrieve datasheet evidence": "wikiDisplay.review.retrieve",
  檢索規格書證據: "wikiDisplay.review.retrieve",
  提取关键参数: "wikiDisplay.review.extract",
  "Extract key parameters": "wikiDisplay.review.extract",
  擷取關鍵參數: "wikiDisplay.review.extract",
  检查广告与导流: "wikiDisplay.review.advertising",
  "Check advertising and redirects": "wikiDisplay.review.advertising",
  檢查廣告及導流: "wikiDisplay.review.advertising",
  检查内容客观性: "wikiDisplay.review.objectivity",
  "Check content objectivity": "wikiDisplay.review.objectivity",
  檢查內容客觀性: "wikiDisplay.review.objectivity",
  逐项事实核验: "wikiDisplay.review.verify",
  "Verify individual claims": "wikiDisplay.review.verify",
  逐項事實核驗: "wikiDisplay.review.verify",
  审核检查: "wikiDisplay.review.check",
  "Review check": "wikiDisplay.review.check",
  審核檢查: "wikiDisplay.review.check",
  原文支持: "wikiDisplay.review.supported",
  "Supported by the source": "wikiDisplay.review.supported",
  存在矛盾: "wikiDisplay.review.contradicted",
  "Contradicted by the source": "wikiDisplay.review.contradicted",
  证据不足: "wikiDisplay.review.insufficient",
  "Insufficient evidence": "wikiDisplay.review.insufficient",
  證據不足: "wikiDisplay.review.insufficient",
  待核验: "wikiDisplay.review.unverified",
  "Awaiting verification": "wikiDisplay.review.unverified",
  待核驗: "wikiDisplay.review.unverified",
});
